<template>
  <div
    v-if="remission"
    @click.stop="remissionView"
    class="sale-document-body md__border border-radius bg-color-write p-3 mb-2 cursor-point"
    :class="{ 'signing-card--active': isSigning }"
  >
    <div class="sale-document-info">
      <div class="sale-document-description d-flex justify-content-between">
        <div class="info">
          <p class="m-0 text-color-primary str-limit-space">
            N° {{ remission.number_remission }}
          </p>
          <p class="m-0 font-bold text-color-primary str-limit-space">
            {{ remission.destination_name }}
          </p>
          <p class="m-0">
            <small>
              <span class="font-semi-bold mr-2">{{
                remission.carrier_name
              }}</span>
            </small>
          </p>
        </div>
        <div class="sale-document-number">
          <span class="card-date">{{ remission.emission_date_for_view }}</span>
        </div>
      </div>
    </div>

    <div
      class="sale-document-actions d-flex justify-content-between align-items-center mt-4"
    >
      <div class="status d-flex">
        <template v-if="isSigning">
          <span class="signing-badge">
            <span class="signing-badge__spinner"></span>
            Firmando...
          </span>
        </template>
        <StatusReadDocumentsComponent
          v-else
          :status.sync="remission.status"
          typeStatus="short"
        />
      </div>
      <div class="next" @click.stop>
        <RemissionOptionsByStatus
          :status="remission.status"
          :id="remission.id"
          @goPage="goRouter"
          @onSigningStart="isSigning = true"
          @onSigningDone="onSigningDone"
          @onSigningError="isSigning = false"
          @onDocDeleted="id => $emit('onDocDeleted', id)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import StatusReadDocumentsComponent from "../../../../components/StatusReadDocuments";
import RemissionOptionsByStatus from "./RemissionOptionsByStatus";

export default {
  name: "RemissionCardComponent",
  data() {
    return { isSigning: false };
  },
  methods: {
    onSigningDone({ id, data }) {
      this.isSigning = false;
      if (data) this.$emit("onDocUpdate", { id, data });
    },
    goRouter(name, params = {}) {
      this.$router.push({ name, params });
    },
    remissionView() {
      this.goRouter("sales.remissions.view", { id: this.remission.id });
    }
  },
  components: { StatusReadDocumentsComponent, RemissionOptionsByStatus },
  props: {
    remission: {
      type: Object,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
.signing-card--active {
  opacity: 0.45;
  pointer-events: none;
  transition: opacity 0.2s ease;
}
.signing-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 500;
  color: #534ab7;
  background: #eeedfe;
  border-radius: 10px;
  padding: 2px 8px;
  &__spinner {
    width: 10px;
    height: 10px;
    border: 1.5px solid #eeedfe;
    border-top-color: #534ab7;
    border-radius: 50%;
    animation: signing-card-spin 0.7s linear infinite;
  }
}
@keyframes signing-card-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
